module.exports = __webpack_public_path__ + "media/images/md-logo-wt-f8ebd4983b55f96c8fdd858698bfddcb.svg";